import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { JsonResult } from '../core/json-result.model';
import { EnvironmentService } from '../core/services/environment.service';
import { CommonService } from './common.service';
import { takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BannerService {
  private controller: string = 'Banner';
  constructor(private httpClient: HttpClient,
    private environmentService: EnvironmentService,
    private commonService: CommonService) { }

  getBanners() {
    let url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}/GetBanners`;
    return this.httpClient.get<JsonResult<any[]>>(url).pipe(takeUntil(this.commonService.unauthorizedAnnounced));
  }

  getbannerByUser(codClientType)
  {
    let url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}/GetBannersWeb/${codClientType}`;
    return this.httpClient.get<JsonResult<any[]>>(url).pipe(takeUntil(this.commonService.unauthorizedAnnounced));
  }
}